import { inject, Injectable } from '@angular/core';

import { Store } from '@ngrx/store';

import { AbilitiesSelectors } from '@core/abilities-data';
import { Ability } from '@core/abilities-types';

@Injectable({ providedIn: 'root' })
export class DashboardService {
  private readonly store = inject(Store);

  public hasCalendarPage = this.store.selectSignal(AbilitiesSelectors.hasOne(Ability.ViewCalendar));
}
